import React from "react";
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";
import RenderIf from "./RenderIf";

const Generic = ({
  text = "",
  title = "",
  description='',
}) => {

  return (
    <General.BlockContainer align="center">
      <General.Block>
        <FloatCard width="300px">
          <General.InputCont>
            <General.LimitText width="250px">{text}</General.LimitText>
          </General.InputCont>
        </FloatCard>
      </General.Block>
      <General.Block color={theme.colors.grey4}>
        <div>
          <h2>{title}</h2>
          <RenderIf isTrue={description.length > 0}>
            <General.LimitText width="250px">{description}</General.LimitText>
          </RenderIf>
        </div>
      </General.Block>
    </General.BlockContainer>
  );
};

export default Generic;
